export default "__VITE_ASSET__ISco4xzl__"